import useBreakpoints from '../useBreakpoints';

var useIsDesktop = function useIsDesktop() {
  var _useBreakpoints = useBreakpoints(),
      isAboveBreakpoint = _useBreakpoints.isAboveBreakpoint;

  return isAboveBreakpoint('lg', true);
};

export default useIsDesktop;